module.exports = __webpack_public_path__ + "static/media/family tree in sky blue.0c2a783a.svg";